package de.xtl.retroguide.question.scenes

import androidx.compose.runtime.Composable
import de.xtl.retroguide.protocol.AnswerCategory
import de.xtl.retroguide.protocol.QuestionWidget
import de.xtl.retroguide.protocol.categories

/** Animated illustration shown above the grouped answers of a category widget. */
@Composable
internal fun CategoryScene(widget: QuestionWidget, counts: Map<AnswerCategory, Int>) {
    when (widget) {
        QuestionWidget.SAILBOAT -> SailboatScene(counts)
        QuestionWidget.HOT_AIR_BALLOON -> HotAirBalloonScene(counts)
        QuestionWidget.SPEEDCAR -> SpeedcarScene(counts)
        QuestionWidget.MAD_SAD_GLAD -> MoodFacesScene(counts)
        QuestionWidget.STARFISH -> StarfishScene(counts)
        QuestionWidget.FOUR_L, QuestionWidget.KALM, QuestionWidget.DAKI -> QuadrantScene(widget.categories, counts)
        QuestionWidget.TEXT, QuestionWidget.BATTERY, QuestionWidget.WEATHER, QuestionWidget.ROTI,
        QuestionWidget.TEAM_RADAR, QuestionWidget.DOT_VOTING, QuestionWidget.ACTION_ITEMS -> Unit
    }
}
